import React from "react";
import "./App.css";
import "./App.responsive.css";
import "./components/Components.css";
import "./components/Components.responsive.css";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import LandingSite from "./sites/landing/LandingSite";
import CreateNewDelivery from "./sites/createNewDelivery/CreateNewDelivery";
import UpdateDelivery from "./sites/updateDelivery/UpdateDelivery";
import UnsuccessfulDelivery from "./sites/unsuccessfulDelivery/UnsuccessfulDelivery";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This function is the entry point of the WebApp. It will create a route for navigating.
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 * @constructor
 */
function App() {
  return (
    <Router>
      <Switch>
        <Route path="/newDelivery">
          <CreateNewDelivery />
        </Route>
        <Route path="/updateDelivery">
          <UpdateDelivery />
        </Route>
        <Route path="/unsuccessfulDelivery">
          <UnsuccessfulDelivery />
        </Route>
        <Route>
          <LandingSite />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
